import React from "react";
import * as styles from "./Dashboard.module.css";
import { productCardDetails as cards } from "../../utils/constants";

export default function Dashboard() {
  return (
    <section
      className={styles.dashboardSection}
      aria-labelledby="dashboard-cards-heading"
    >
      <h2 id="dashboard-cards-heading" className={styles.dashboardHeading}>
        Dashboard Features
      </h2>

      <div className={styles.cardGrid}>
        {cards.map(({ title, icon, description, link }) => (
          <a
            key={title}
            className={`${styles.cardItem} blur_card`}
            href={link}
            target="_blank"
          >
            <div className={`${styles.card}`}>
              <img
                src={icon}
                alt=""
                aria-hidden="true"
                className={styles.cardIcon}
              />
              <h3 className={styles.cardTitle}>{title}</h3>
              <p className={styles.cardDescription}>{description}</p>
            </div>
          </a>
        ))}
      </div>
    </section>
  );
}
